export default {
  'common.ReLogin': '重新登录',
  'common.ChangePassword': '修改密码',
  'common.Logout': '登出',
  'common.LoginStatusInvalid': '登录状态已失效，请重新登录！',
  'common.BackHome': '返回首页',
  'message.HTTP_403': '抱歉，您无权访问此页面。',
  'message.HTTP_404': '抱歉，您访问的页面不存在。',
};
